import { Component } from "@theme/component";

class StickyScrollToAtc extends Component {
  requiredRefs = ["stickyBar"];

  #buyButtonsObserver = null;
  #footerObserver = null;
  #isSticky = false;
  #hiddenInFooter = false;

  connectedCallback() {
    super.connectedCallback();
    this.#setupObservers();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#buyButtonsObserver?.disconnect();
    this.#footerObserver?.disconnect();
  }

  updatedCallback() {
    super.updatedCallback?.();
    this.#buyButtonsObserver?.disconnect();
    this.#footerObserver?.disconnect();
    this.#setupObservers();
  }

  #getBuyButtonsBlock() {
    const section = this.closest(".shopify-section");
    return section?.querySelector(".buy-buttons-block") ?? null;
  }

  #setupObservers() {
    const buyButtonsBlock = this.#getBuyButtonsBlock();
    if (!buyButtonsBlock) return;

    const footer =
      document.querySelector("footer") ??
      document.querySelector(".shopify-section-group-footer-group");

    this.#buyButtonsObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (!entry) return;

      if (!entry.isIntersecting && !this.#isSticky) {
        const rect = entry.target.getBoundingClientRect();
        if (rect.bottom < 0) {
          this.#show();
        }
      } else if (this.#isSticky && entry.isIntersecting) {
        this.#hiddenInFooter = false;
        this.#hide();
      }
    });
    this.#buyButtonsObserver.observe(buyButtonsBlock);

    if (footer) {
      this.#footerObserver = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (!entry) return;

          if (entry.isIntersecting && this.#isSticky) {
            this.#hiddenInFooter = true;
            this.#hide();
          } else if (!entry.isIntersecting && this.#hiddenInFooter) {
            const rect = buyButtonsBlock.getBoundingClientRect();
            if (rect.bottom < 0) {
              this.#hiddenInFooter = false;
              this.#show();
            }
          }
        },
        { rootMargin: "0px 0px -200px 0px" }
      );
      this.#footerObserver.observe(footer);
    }
  }

  handleScrollToAtcClick = () => {
    const buyButtonsBlock = this.#getBuyButtonsBlock();
    if (!buyButtonsBlock) return;

    const header =
      document.querySelector(".shopify-section-group-header-group") ??
      document.querySelector("header");
    const headerOffset = header?.getBoundingClientRect().height ?? 0;

    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    const rect = buyButtonsBlock.getBoundingClientRect();
    const target = Math.max(0, window.scrollY + rect.top - headerOffset - 16);

    window.scrollTo({ top: target, behavior: reduce ? "auto" : "smooth" });

    const atcButton = buyButtonsBlock.querySelector('[ref="addToCartButton"]');
    atcButton?.focus?.({ preventScroll: true });
  };

  #show() {
    this.#isSticky = true;
    this.refs.stickyBar.dataset.sticky = "true";
  }

  #hide() {
    this.#isSticky = false;
    this.refs.stickyBar.dataset.sticky = "false";
  }
}

if (!customElements.get("sticky-scroll-to-atc")) {
  customElements.define("sticky-scroll-to-atc", StickyScrollToAtc);
}
